"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const script_1 = __importDefault(require("next/script"));
const safevalues_1 = require("safevalues");
/**
 * A RecaptchaScript component that initializes the Google reCAPTCHA script.
 */
const RecaptchaScript = ({ siteKey }) => {
    const recaptchaScriptUrl = (0, safevalues_1.trustedResourceUrl) `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
    return ((0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-recaptcha", src: recaptchaScriptUrl, strategy: "lazyOnload" }));
};
exports.default = RecaptchaScript;
